import { RouteRecordRaw } from 'vue-router';

const routePrefix = "/fn/";

const financePageRoutes: RouteRecordRaw[] = [
    {
        path: `${routePrefix}costcenter`,
        name: "fn-CostCenter",
        component: () => import("@/components/finance/features/CostCenter/CostCenterComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'costCenter'],
        },
    },
    {
        path: `${routePrefix}costcentergroup`,
        name: "fn-CostCenterGroup",
        component: () => import("@/components/finance/features/CostCenter/CostCenterGroupComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'costCenter', 'costCenterGroup'],
         },
    },
    {
        path: `${routePrefix}counterpart`,
        name: "fn-CounterPart",
        component: () => import("@/components/finance/features/CounterPart/CounterPartComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'counterPart'],
        },
    },
    {
        path: `${routePrefix}counterpartgroup`,
        name: "fn-CounterPartGroup",
        component: () => import("@/components/finance/features/CounterPart/CounterPartGroupComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'counterPart', 'counterPartGroup'],
        },
    },
    {
        path: `${routePrefix}project`,
        name: "fn-Project",
        component: () => import("@/components/finance/features/Project/ProjectComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'project'],
        },
    },
    {
        path: `${routePrefix}projectgroup`,
        name: "fn-ProjectGroup",
        component: () => import("@/components/finance/features/Project/ProjectGroupComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'project', 'projectGroup'],
        },
    },

    {
        path: `${routePrefix}employee`,
        name: "fn-Employee",
        component: () => import("@/components/finance/features/Employee/EmployeeComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'employee'],
        },
    },
    {
        path: `${routePrefix}financialyear`,
        name: "fn-FinancialYear2",
        component: () => import("@/components/finance/features/FinancialYear/FinancialYearComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'financialYear'],
        },
    },
    {
        path: `${routePrefix}account`,
        name: "fn-Account",
        component: () => import("@/components/finance/features/Account/AccountComponent.vue"),
        meta: {
            requiresAuth: true,
            titleTrail: ['finance', 'account'],
        },
    },
    {
        path: `${routePrefix}accountgroup`,
        name: "fn-AccountGroup",
        component: () => import("@/components/finance/features/Account/AccountGroupComponent.vue"),
        meta: {
            requiresAuth: true,
            titleTrail: ['finance', 'account', 'accountGroup'],
        },
    },
    {
        path: `${routePrefix}pldesign`,
        name: "fn-P&LDesign",
        component: () => import("@/components/finance/features/P&LDesign/ResultSheetDesign.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'p&lDesign'],
        },
    },
    {
        path: `${routePrefix}article`,
        name: "fn-Article",
        component: () => import("@/components/finance/features/Article/ArticleComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'article'],
        },
    },
    {
        path: `${routePrefix}articlegroup`,
        name: "fn-ArticleGroup",
        component: () => import("@/components/finance/features/Article/ArticleGroupComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'article', 'articleGroup'],
        },
    },
    {
        path: `${routePrefix}balancesheetdesign`,
        name: "fn-BalanceSheetDesign",
        component: () => import("@/components/finance/features/BalanceSheets/BalanceSheetDesign.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'balanceSheetDesign'],
        },
    },
    {
        path: `${routePrefix}invoice`,
        name: "fn-Invoice",
        component: () => import("@/components/finance/features/Invoice/InvoiceComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'invoice'],
        },
    },
    {
        path: `${routePrefix}budgetforecast`,
        name: "fn-BudgetForecast",
        component: () => import("@/components/finance/features/BudgetForecast/BudgetForecastComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['budgetForecast', 'budgetForecastV2'],
         },
    },
    {
        path: `${routePrefix}budgetforecastpermission`,
        name: "fn-BudgetForecastPermission",
        component: () => import("@/components/finance/features/BudgetForecastPermission/BudgetForecastPermissionComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['budgetForecast', 'budgetForecastPermissions'],
         },
    },
    {
        path: `${routePrefix}datasyncconfig`,
        name: "fn-DataSyncConfig",
        component: () => import("@/components/finance/features/DataSyncConfig/DataSyncConfigComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'dataSyncConfig'],
         },
    },
    {
        path: `${routePrefix}customcompany`,
        name: "fn-CustomCompany",
        component: () => import("@/components/finance/features/Stg_Company/Stg_companyComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['finance', 'customCompany'],
         },
    },
    {
        path: `${routePrefix}budgetforecastsyncsetting`,
        name: "fn-BudgetForecastSyncSetting",
        component: () => import("@/components/finance/features/BudgetForecastSyncSetting/BudgetForecastSyncSettingComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['budgetForecast', 'actualSyncSetting'],
         },
    },
];

export default financePageRoutes;